module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00046.ee44476.png";